// 清理微信空间——主流程
const MainRoutes = Array.from({ length: 16 }, (_, i) => ({
  path: `space/index${i + 1}`,
  name: `spaceIndex${i + 1}`,
  component: () => import(`@/views/wxSettings/space/index${i + 1}.vue`)
}))



export default {
  path: '/wxSettings',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 设置闹钟——主流程，开始
    ...MainRoutes,

  ],
};
